import { render, staticRenderFns } from "./category-card-catalogue.vue?vue&type=template&id=7b0169a5&scoped=true"
import script from "./category-card-catalogue.vue?vue&type=script&lang=js"
export * from "./category-card-catalogue.vue?vue&type=script&lang=js"
import style0 from "./category-card-catalogue.vue?vue&type=style&index=0&id=7b0169a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0169a5",
  null
  
)

export default component.exports